import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import { useFormSelector } from '../../../custom-hooks';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_BORDER_STYLES, FCM_HIDDEN_CONTROL_STYLES } from '../../constants/runtime.constants';
import { getIsControlAdded, getIsControlChanged } from '../../selectors/form-manager.selectors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  changesModeWrapper: {
    display: 'flex',
    padding: ({ isControlAdded }) =>
      `4px ${isControlAdded ? 0 : 4}px ${isControlAdded ? 4 : 0}px 4px`,
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  control: {
    marginRight: 8,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
});

const ColumnFCM = ({ id, title, isHidden }) => {
  const isControlAdded = useFormSelector(getIsControlAdded, { id });
  const isControlChanged = useFormSelector(getIsControlChanged, { id });
  const classes = useStyles({ isControlAddedFCM: isControlAdded });

  if (isControlAdded || isControlChanged) {
    return (
      <div className={classes.root}>
        <div className={classes.changesModeWrapper} data-ss-id={id}>
          <div
            className={classNames(classes.control, isHidden ? classes.hiddenControl : '')}
            data-hidden-fcm={isHidden}
          >
            {title}
          </div>
          {isControlChanged && <ControlChangesIcon id={id} />}
        </div>
      </div>
    );
  }

  if (isHidden) {
    return (
      <span className={classes.hiddenControl} data-hidden-fcm="true" data-ss-id={id}>
        {title}
      </span>
    );
  }

  return <span data-ss-id={id}>{title}</span>;
};

export const getColumnFCM = (id, title, isHidden) => (
  <ColumnFCM id={id} title={title} isHidden={isHidden} />
);

export default ColumnFCM;
